function isHostComponent(element) {
  return typeof element === 'string';
}

export default isHostComponent;